import React from "react";
import { Title, ItemsContainer, Item, LinkStyle } from "../CommonStyles";
import Row from "../../Shared/Kit/Row";
import DownloadIcon from "../../Assets/Icons/DownloadIcon";

const itemConfig = [
  "بازدید از ساعت 15-9 روزهای کاری 1403/02/08 الی 1403/02/31 و انتخاب واحد مورد نظر از واحدهای باقیمانده",
  "اخذ قیمت پایه کارشناسی واحد موردنظر از طریق تماس با تلفن شماره 8-22884683 داخلی 114 سرکار خانم اسمعیلی ",
  "تکمیل فرم پیشنهاد قیمت (قابل پرینت از سامانه) در سایت مؤسسه رفاه و تامین آتیه کارکنان بانک سپه",
  "تکمیل فرم مربوطه برای واحد مورد نظر با درج قیمت پیشنهادی و ارائه آن در پاکت در بسته  به موسسه (از تاریخ 1403/02/16 الی 1403/03/10) و در پشت پاکت شماره واحد پیشنهادی، طبقه آن و نام خانوادگی پیشنهاد دهنده قید و امضا شود.",
  "با توجه به اینکه واحدهای مسکونی آماده تحویل و انتقال سند می باشند به جهت مساعدت با همکاران به منظور تأمین نقدینگی شرایط پرداخت برای همکاران بانکی به صورت ذیل می باشد:",
  "60 درصد نقد در زمان تنظیم مبایعه نامه - 30 درصد موقع تحویل (یک ماهه بعد از تاریخ تنظیم مبایعه نامه) - 10 درصد زمان انتقال سند.",
];

const Section1 = () => {
  return (
    <>
      <Title>شرایط خرید واحد های مسکونی باقیمانده برج اسپاد ویژه همکاران</Title>
      <ItemsContainer className="p-r">
        {itemConfig.map((each, index) => {
          return (
            <Item key={index}>
              <Row className="description">
                {index + 1}. &nbsp;
                {each}
              </Row>
            </Item>
          );
        })}
         <LinkStyle
          className="download"
          href={"/Assets/Files/NoticeAttached3.jpg"}
          target="_blank"
        >
         نامه رسمی شرایط خرید
          <DownloadIcon />
        </LinkStyle>
        {/* <LinkStyle
          className="download"
          href={"/Assets/Files/NoticeAttached2.jpg"}
          target="_blank"
        >
         نامه رسمی شرایط خرید
          <DownloadIcon />
        </LinkStyle> */}
        <LinkStyle
          className="download"
          href={"/Assets/Files/NoticeAttached1.jpg"}
          target="_blank"
        >
          فایل پیوست
          <DownloadIcon />
        </LinkStyle>
      </ItemsContainer>
    </>
  );
};

export default Section1;
